import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { ICustomHeaderProps } from 'app/types';
import { useNavigation } from '@react-navigation/native';
import { Icon } from '../Icon/Icon';
import { Head } from '@shared/components/head';
import { Text } from '@shared/components/text';
import { colorPalette } from '@shared/config/colorsConfig';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';

export const BackStackNavHeader: React.FC<ICustomHeaderProps> = ({
    style = {},
    title,
    backText,
    showBackText,
    customNavigation,
    backIcon = 'left'
}) => {
    const navigation = useNavigation();
    const { t } = dynamicTranslations();
    const resolvedBackText = backText ?? t('buttons.back');
    const resolvedShowBackText = showBackText ?? !title;

    let insets;
    try {
        insets = useSafeAreaInsets();
    } catch (error) {
        console.warn('SafeAreaInsets not available, using fallback:', error);
        insets = { top: 0, bottom: 0, left: 0, right: 0 };
    }

    return (
        <View
            className={`px-6 pb-5 flex-row items-center gap-4 bg-white${title ? ' border-b border-gray-200' : ''}${backIcon === 'close' ? ' justify-end' : ''}`}
            style={{ paddingTop: insets.top + 16, ...style }}
        >
            {backIcon === 'left' && (
                <TouchableOpacity
                    onPress={() => customNavigation ? customNavigation() : navigation.goBack()}
                    className="flex-row items-center gap-2"
                >
                    <View className="w-11 h-11 rounded-full border border-gray-300 justify-center items-center">
                        <Icon name="left" size={20} color={colorPalette.primary[700]} />
                    </View>
                    {resolvedShowBackText && <Text className="text-md font-semibold text-gray-500 underline">{resolvedBackText}</Text>}
                </TouchableOpacity>
            )}
            {!!title && <Head type="h2" className="flex-1">{title}</Head>}
            {backIcon === 'close' && (
                <TouchableOpacity
                    onPress={() => customNavigation ? customNavigation() : navigation.goBack()}
                >
                    <View className="w-11 h-11 rounded-full border border-gray-300 justify-center items-center">
                        <Icon name="close" size={20} color={colorPalette.primary[700]} />
                    </View>
                </TouchableOpacity>
            )}
        </View>
    );
};

BackStackNavHeader.displayName = 'BackStackNavHeader';
